module.exports = __webpack_public_path__ + "img/train-11.52f3b728.jpg";